import { render, staticRenderFns } from "./ForbiddenPage.vue?vue&type=template&id=1ae42a5f&"
import script from "./ForbiddenPage.vue?vue&type=script&lang=js&"
export * from "./ForbiddenPage.vue?vue&type=script&lang=js&"
import style0 from "./ForbiddenPage.vue?vue&type=style&index=0&id=1ae42a5f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports